import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { getLocalStorageValue } from "utils/handler";
import logo from '../../../assets/img/saw-logo.png';
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { getCalendly } from "store/actions/auth.action";
import AccordionItem from "./AccordianItem";
import PaymentLoadingFiller from "./PaymentLoadingFiller";

type CalendlyProps = {

};

const data = [
    { title: "Who are you?", content: "Saw.com specializes in acquiring the right domain for your business. We have helped thousands of companies do exactly that. Google us or read our Trustpilot reviews to see for yourself." },
    { title: "How much will the domain name cost?", content: "Every domain is different. Factors like the extension, comparable sales, and market demand all play a role. One of our specialists will give you an appraisal during your consultation." },
    { title: "How long will it take?", content: "Typically anywhere from a few days to several weeks. It depends on how quickly the owner responds and how smoothly negotiations go" },
    { title: "What do you charge for your service?", content: "Our fee is 15% of the negotiated purchase price. A minimum fee of $250 applies." },
    { title: "Do you contact the owner on my behalf anonymously?", content: "Yes. We keep your privacy protected throughout the negotiation." },
    { title: "Do I still pay if the negotiation fails?", content: "You do not pay our commission unless we successfully acquire the domain for you." },
    { title: "How do you determine what to offer?", content: "We assess multiple metrics to appraise the domain and evaluate the owner's situation, developing a strategy that gets you the best possible price without overpaying." },
    { title: "What if I do not want to use Saw.com to pay for the domain?", content: "We support a range of trusted payment providers including Escrow.com, Escrow.Domains, industry lawyers, and other well known marketplaces. Tell us your preference when you speak with one of our specialists." },
    { title: "Can you help me acquire domains in any country extension?", content: "Absolutely. Whether it's a .com, a country-specific extension, or anything in between, we have the experience and connections to pursue it on your behalf." },
];

const Calendly: React.FC<CalendlyProps> = ({ }) => {
    const history = useHistory();

    const [leadID, setLeadID] = useState(() => {
        return getLocalStorageValue("tempLeadID");
    });
    const [agentCalendly, setAgentCalendly] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [openIndex, setOpenIndex] = useState<null | number>(null);
    const [isCalenllyLoaded, setIsCalendlyLoaded] = useState(false);
    const [calendlyHeight, setCalendlyHeight] = useState("")

    useCalendlyEventListener({
        onPageHeightResize: (e) => {
            console.log(e.data.payload.height)
            setCalendlyHeight(`${e.data.payload.height}`)
        },
    });

    useEffect(() => {
        if (!leadID) {
            history.push("/");
        } else {
            fetchAgentCalendly(leadID);
        }
    }, [history, leadID])

    useEffect(() => {
        const handleCalendlyEvent = (e: MessageEvent) => {
            if (e.data.event && e.data.event === "calendly.event_type_viewed") {
                setIsCalendlyLoaded(true);
            }
        };

        window.addEventListener("message", handleCalendlyEvent);

        return () => {
            window.removeEventListener("message", handleCalendlyEvent);
        };
    }, []);

    const fetchAgentCalendly = async (leadUID: string) => {
        const calendlyRes = await getCalendly(leadUID);
        if (calendlyRes?.agent) {
            setAgentCalendly(calendlyRes.agent);
            setName(calendlyRes.user?.name || "");
            setEmail(calendlyRes.user?.email || "");
        } else {
            history.push("/");
        }
    }


    return (
        <div className='rewamped-calendly-page'>
            <img height="50px" alt="logo-png" src={logo} className="payment-page-logo" style={{ cursor: "pointer" }} onClick={() => { history.push("/") }} />
            {!agentCalendly && <PaymentLoadingFiller />}

            <div className="calendly-wrapper">

                {agentCalendly && <div className="calendly-widget-wrapper">
                    <InlineWidget
                        url={"https://calendly.com/" + agentCalendly + "/15min"}
                        // url={"https://calendly.com/paul-9872/15min"}
                        prefill={{ name, email }}
                        styles={{
                            display: "flex",
                            height: calendlyHeight,
                            width: '100%',
                            overflow: "hidden",
                            marginTop: "0px"
                        }} />
                </div>}
                {agentCalendly && <div className="calendly-faq-wrapper">
                    <div className="heading-faq">Frequently Asked Questions</div>
                    {data.map((item, index) => (
                        <AccordionItem
                            key={index}
                            {...item}
                            isOpen={openIndex === index}
                            onClick={() =>
                                setOpenIndex(openIndex === index ? null : index)
                            }
                        />
                    ))}
                </div>}
            </div>
        </div>)
}

export default Calendly;